import { serialize, getToken, base64Encode } from './utils'

const version = '/apis/client/v1'
const commonv1 = '/apis/common/v1'

// const version = 'http://prd.ourchoice.cn/apis/client/v1'
// const commonv1 = 'http://prd.ourchoice.cn/apis/common/v1'


export const fetch = async (url = '', options = {}) => {
  const newUrl = /\?/.test(url) ? `${url}${/(&|\?)$/.test(url) ? '' : '&'}_t=${Date.now()}` : `${url}?_t=${Date.now()}`
  const headers = Object.prototype.toString.call(options.body) === '[object FormData]' ? {} : {'Content-Type': 'application/json'}

  return await window.fetch((!/^https?:\/\//.test(url) ? process.env.API : '') + newUrl, {
    method: 'GET', // *GET, POST, PUT, DELETE, etc.
    mode: 'cors', // no-cors, *cors, same-origin
    cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
    // credentials: 'same-origin', // include, *same-origin, omit
    ...options,
    headers: {
      'Authorization': 'Bearer ' + getToken(),
      ...headers,
      ...(options.headers || {})
    },
  }).then(res => {
    const json = res.json()

    if (res.status === 500) {
      // toast(json && (json.message || json.error) || '服务器错误')
      return json
    }

    return json
  }).then(json => {
    if (json.recode === 500 && json.msg) {
      // toast(json.msg)
    }

    return json
  }).catch(err => {
    if (Object.prototype.toString.call(err) === '[object Error]') {
      return {}
    }

    return err
  })
}

/**
 * 获取用户信息
 */
export const getUser = () => (
  fetch(`${version}/users/current_user`)
)

/**
 * 商品联想
 */
export const getProductHint = ({merchantCode, keyword, num}) => (
  fetch(serialize({keyword, num}, `${version}/products/${merchantCode}/hint`))
)

/**
 * 获取商品列表
 */
export const getProductsSearch = (params = {}) => {
  return fetch(`${version}/products/search`, {
    method: 'post',
    body: JSON.stringify({...params, size: 20})
  })
}

/**
 * 获取商品详情
 */
export const getProduct = ({merchantCode, productCode}) => (
  fetch(`${version}/products/${merchantCode}/${productCode}`)
)

/**
 * 获取商品分组列表
 */
export const getProductGroup = ({merchantCode, productCode, directDeliveryFlag, promotionCode, couponCode, showOwnProduct, recentlyBoughtFlag}) => (
  fetch(serialize({directDeliveryFlag, promotionCode, couponCode, showOwnProduct, recentlyBoughtFlag}, `${version}/products/group/${merchantCode}/${productCode}`))
)

/**
 * 获取店铺详情
 */
export const getStore = ({merchantCode, errorCode}) => (
  fetch(`${version}/stores/${merchantCode}`, {}, errorCode)
)

/**
 * 获取店铺详情名称
 */
export const getStoreName = ({merchantCode}) => (
  fetch(`${version}/stores/${merchantCode}/name`)
)

/**
 * 获取店铺分类
 */
export const getCategories = ({merchantCode}) => {
  const categories = JSON.parse(localStorage.getItem(`categories-${merchantCode}`))

  if (merchantCode === '865833' && categories && categories.time + (30 * 24 * 60 * 60 * 1000) > Date.now() && Array.isArray(categories.categories) && categories.categories.length > 0) {
    return new Promise(reslove => {
      reslove({recode: 200, categories: categories.categories})
    })
  }

  return fetch(`${version}/categories/${merchantCode}`).then(res => {
    if (res && Array.isArray(res.categories) && res.categories.length > 0) {
      localStorage.setItem(`categories-${merchantCode}`, JSON.stringify({time: Date.now(), categories: res.categories}))
    }
    return res
  })
}

export const createIcpOrder = (body) => (
  fetch(`${version}/icpOrders`, {
    method: 'POST',
    body: JSON.stringify(body)
  })
)

/**
 * 订单列表
 */
export const getOrdersList = ({productName, orderCode, orderStatus, page = 1, size = 10}) => (

  fetch(serialize({productName, orderCode, orderStatus: orderStatus == 1 ? '' : orderStatus, page, size}, `${version}/icpOrders`))
)
/**
 * 订单列表统计
 */
export const getOrdersCount = () => (
  fetch(serialize({}, `${version}/icpOrders/count`))
)


/**
 * 订单删除
 */
export const deleteOrder = ({orderCode}) => (
  fetch(serialize({}, `${version}/icpOrders/${orderCode}`), {
    method: 'DELETE',
  })
)


/**
 * 订单退款
 */
export const returnOrderPay = ({orderCode}) => (
  fetch(serialize({}, `${version}/allinpay/pc/refund`), {
    method: 'POST',
    body: JSON.stringify({orderCode})
  })
)


/**
 * 订单支付二维码
 */
export const getPayQrcode = ({orderCode, paymentType=20, channelType=40}) => (
  fetch(serialize({}, `${version}/allinpay/pc/pay`), {
    method: 'POST',
    body: JSON.stringify({orderCode, paymentType, channelType})
  })
)

/**
 * useerInfo
 */
export const getUserInfo = () => (
  fetch(`${commonv1}/users/current_user`)
)

/**
 * 通联-注册账号
 */
export const createTlUser = () => (
  fetch(`${version}/allinpay/create`, {
    method: 'POST',
  })
)

/**
 * 通联-发送短信验证码
 */
export const getTlIdentifyCode = (phone = '') => (
  fetch(`${version}/allinpay/sendVerificationCode`, {
    method: 'POST',
    body: JSON.stringify({phone})
  })
)

/**
 * 通联-关联手机号
 */
export const tlBindPhone = (phone = '', verifyCode = '') => (
  fetch(`${version}/allinpay/bindPhone`, {
    method: 'POST',
    body: JSON.stringify({phone, verifyCode})
  })
)


export const getAccessToken = (phone='', code='') => {
  return fetch(
    `/auth/api/auth2u/token?grant_type=verification_code&client_type=pc`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Basic ${base64Encode(phone + ':' + code)}`
      }
    }
  )
}

export const getIdentifyCode = (query = {}) => {
  return fetch(serialize(query, '/apis/common/v1/sms/verifyCode/identifyCode'))
}

export const register = (body) => {
  return fetch(
    `/apis/common/v1/users/registerUser`,
    {
      method: 'POST',
      body: JSON.stringify(body)
    }
  )
}